import { PipeObject, Token, Replacement } from '../types';

export const BoldItalic = () => {
  return ({ input, lex, data }: PipeObject) => {
    let obj: Token;

    let replacements: Replacement[] = [];
    while ((obj = lex.next())) {
      switch (obj.token) {
        case 'bold':
          replacements.push({
            searchValue: input.substring(obj.begin, obj.end + 1),
            replaceValue: `<b>${obj.value}</b>`,
          });
          break;
        case 'bold_italic':
          replacements.push({
            searchValue: input.substring(obj.begin, obj.end + 1),
            replaceValue: `<b><i>${obj.value}</i></b>`,
          });

          break;
        case 'italic':
          replacements.push({
            searchValue: input.substring(obj.begin, obj.end + 1),
            replaceValue: `<i>${obj.value}</i>`,
          });
          break;
      }
    }

    for (const rep of replacements) {
      input = input.replace(rep.searchValue, rep.replaceValue);
    }

    // replace all *text* with regex
    // special case as * is used by the lexer, and it breaks when a single one is present
    const italicRegex = /[^\\]\*(.*?[^\/])\*/g;
    const match = input.match(italicRegex);
    if (match && match.length > 0) {
      for (let ita of match) {
        // check if charAt(0) == *, if not, move it over one
        if (ita.charAt(0) != '*') {
          ita = ita.substring(1);
        }
        input = input.replace(ita, `<i>${ita.replace(/\*/g, '')}</i>`);
      }
    }

    // replace escaped * (\*) with single * - another special case!
    input = input.replace(/\\\*/g, '*');

    return { input, lex, data };
  };
};
